import checkTrue from '../../Assets/layout_icons/checkTrue.png'
import unique from '../../Assets/layout_images/humanai.png'
import {
    HeadingContainer,
    BadgeHeading,
    SectionHeading,
    HeadingDescription,
    GradientText
} from './HeadingComponenents'

import {
    HeadingGradientShift,
    HeadingScaleGlow,
    HeadingUnderline,
    HeadingGradientUnderline,
    HeadingPulse
} from './Headinghovercomponents'

export default function UniqueHome() {
    const pointsUnique = [
        {
            title: 'Student–Teacher Bond',
            content:
                'Every child learns with a caring tutor who offers the personal support AI can’t replace.'
        },
        {
            title: 'AI-Powered Learning',
            content:
                'Our AI tracks performance, spots weaknesses, and creates personalized revision plans and tests.'
        },
        {
            title: '“Meet Your Academic Friend” Sessions',
            content:
                ' Monthly sessions help parents and students review progress and get guided academic support'
        }
    ]
    return (
        <div className="unique_home">
            <div>
                <HeadingContainer>
                    <HeadingGradientShift><HeadingPulse>
                        <SectionHeading>
                            Why we value <GradientText>“Human + AI” </GradientText> in Education
                        </SectionHeading>
                        </HeadingPulse>
                    </HeadingGradientShift>
                </HeadingContainer>
                
                <div className="home_teacherind_unique">
                    <div className="lg_unique_img">
                        <img src={unique} alt="unique" />
                    </div>
                    <div className="unique_points">
                        {pointsUnique.map((el, key) => (
                            <div key={key}>
                                <img src={checkTrue} alt="tick" />
                                <div>
                                    <h3 className="font-Quick font-bold">
                                        {el.title}
                                    </h3>
                                    <p className="font-Quick font-med">
                                        {el.content}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
